/* eslint-disable */
import * as d3 from 'd3';
import * as Lib from '../../../../constants/annotator'

export const xScale = (domain, range, scale) =>
  d3
    .scaleLinear()
    .domain([0, domain])
    .range([0, range * scale]);

export const yScale = (height, scale, mvSwing = 2000) => {
  return d3
    .scaleLinear()
    .domain([mvSwing * -1, mvSwing])
    .range([height, 0]);
};

export const paintSingleLeadWaveform = (
  samples,
  height,
  context,
  scale,
  sliceSize,
  stripWidthPx,
  rows,
  mvSwing = 2000,
  // A larger stride leaves room for other aligned leads between time segments.
  rowStride = height,
) => {
  /* eslint-disable no-param-reassign */
  let sampleSlice;
  let step = 0;

  context.save(); // Since we are transforming the context we need to reset to make sure scale is proper

  for (let j = 0; j < rows; j += 1) {
    sampleSlice = samples.slice(step, step + sliceSize);
    const returnX = (d, k) => xScale(sliceSize, stripWidthPx, scale)(k);
    const returnY = d => yScale(height, scale, mvSwing)(d);
    const line = d3
      .line()
      .x(returnX)
      .y(returnY)
      .context(context);

    if (j !== 0) {
      context.translate(0, rowStride);
    }
    context.beginPath();

    line(sampleSlice);
    context.strokeStyle = Lib.WAVEFORM_BLACK;
    context.lineJoin = "round"
    context.lineWidth = 1.5;
    context.stroke();

    step += sampleSlice.length;
  }

  context.restore(); // Since we are transforming the context we need to reset to make sure scale is proper
};